{
  "seasonId": "00000000-0000-4000-8000-000000000101",
  "club": {
    "id": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
    "code": "D10-G0001-C02",
    "name": "Test FC"
  },
  "matchdayNumber": 8,
  "totalMatchdays": 38,
  "currentMatchdayNumber": 8,
  "previousMatchdayNumber": 7,
  "nextMatchdayNumber": 9,
  "startsAt": "2026-10-08T22:00:00Z",
  "endsAt": "2026-10-12T22:00:00Z",
  "windowStatus": "UPCOMING",
  "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
  "groupName": "Tenth Division Group 0001 Cycle 1",
  "cycleNumber": 1,
  "matchdayId": "acf340ce-6348-42e3-b851-4101fb55a7b9",
  "localMatchdayNumber": 8,
  "status": "PLANNED",
  "scheduleStatus": "AVAILABLE",
  "clubResting": false,
  "fixtures": [
    {
      "id": "62be4ef7-7cc9-4f55-b330-6890cdf8152d",
      "homeClub": {
        "id": "5fde2141-dbbe-501d-859f-ae12674d9a73",
        "code": "D10-G0001-C01",
        "name": "v45cei2znb@test.com Club"
      },
      "awayClub": {
        "id": "c407409d-dcdf-55d7-b455-42bba20c0fc6",
        "code": "D10-G0001-C06",
        "name": "Global D10 G0001 Club 06"
      },
      "status": "PLANNED",
      "homeGoals": null,
      "awayGoals": null
    },
    {
      "id": "9998b884-b18d-46d7-85fd-9329e9a3d1ab",
      "homeClub": {
        "id": "0dec38cf-4f50-59a3-9113-68994b1068e5",
        "code": "D10-G0001-C03",
        "name": "Global D10 G0001 Club 03"
      },
      "awayClub": {
        "id": "b1b387bf-ecee-5890-b5a4-c44f6dcdd840",
        "code": "D10-G0001-C04",
        "name": "Global D10 G0001 Club 04"
      },
      "status": "PLANNED",
      "homeGoals": null,
      "awayGoals": null
    },
    {
      "id": "ecf9dac1-f598-41e6-a3fa-57e962ec53df",
      "homeClub": {
        "id": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
        "code": "D10-G0001-C02",
        "name": "Test FC"
      },
      "awayClub": {
        "id": "7aad7836-724a-5b9c-b8f7-c267fa4f2c86",
        "code": "D10-G0001-C05",
        "name": "Global D10 G0001 Club 05"
      },
      "status": "PLANNED",
      "homeGoals": null,
      "awayGoals": null
    }
  ]
}
